import VModal from "vue-js-modal";
import FontAwesome from "@/plugins/font-awesome";
import Spacer from "@/components/elements/Spacer";
import TextHeadlinePrimary from "@/components/elements/TextHeadlinePrimary";
import TextHeadlineSecondary from "@/components/elements/TextHeadlineSecondary";
import LayoutSplit from "@/components/layouts/LayoutSplit";
import LayoutSingle from "@/components/layouts/LayoutSingle";
import LayoutSquared from "@/components/layouts/LayoutSquared";
import BlockSection from "@/components/blocks/BlockSection";

// eslint-disable-next-line import/no-dynamic-require
const appGlobals = require(`../apps/${process.env.VUE_APP_NAME}/globals`)
    .default;

function dummy(name) {
    return {
        name,
        dummy: true,
        render: h => h("div", { class: "dummy" }, name)
    };
}

// put in cross app global components here
// when component is undefined, it means that the app is required to provide one
const defaultGlobals = {
    spacer: Spacer,
    "text-headline-primary": TextHeadlinePrimary,
    "text-headline-secondary": TextHeadlineSecondary,
    "layout-split": LayoutSplit,
    "layout-single": LayoutSingle,
    "layout-squared": LayoutSquared,
    "block-section": BlockSection,
    spinner: dummy("spinner"),
    "error-image": dummy("error-image"),
    logo: dummy("logo")
};

const globals = { ...defaultGlobals, ...appGlobals };

export default {
    install(Vue) {
        Vue.use(VModal, { componentName: "v-modal" });
        Vue.use(FontAwesome, { componentName: "font-awesome-icon" });
        for (const componentName of Object.keys(globals)) {
            if (globals[componentName].dummy)
                console.warn(
                    "missing required global component " +
                        componentName +
                        ", fallback to using a dummy component"
                );
            Vue.component(componentName, globals[componentName]);
        }
    }
};
